interface IPurpose {
  id: string;
  name: string;
}

export default class Purpose {
  id: string;
  name: string;

  constructor({ id, name }: IPurpose) {
    this.id = id;
    this.name = name;
  }
}